<app-page-header routerLink="/" origin="Home" title="Platform - Status"></app-page-header>

<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>

    <div class="mb-3">
        <button 
            class="btn me-2"
            [class.btn-primary]="activeTab === 'prod'"
            [class.btn-outline-primary]="activeTab !== 'prod'"
            (click)="activeTab = 'prod'">
            Production
        </button>
        <button 
            class="btn me-2"
            [class.btn-primary]="activeTab === 'dev'"
            [class.btn-outline-primary]="activeTab !== 'dev'"
            (click)="activeTab = 'dev'">
            Development
        </button>
    </div>

    <table class="table">
        <thead>
            <tr>
                <th>Titel</th>
                <th>Platform</th>
                <th>URL</th>
                <th>Last build at</th>
                <th>Resync</th>
                <th>Last resync</th>
            </tr>
        </thead>

        <tbody *ngIf="activeTab === 'dev'">
            <tr *ngFor="let item of devItems">

                <td>
                    <span class="status-dot" [ngClass]="item.status"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                     {{ item.title }}
                </td>
                <td>{{ item.group }}</td>

                <td>
                    <a [href]="item.url" target="_blank">{{ item.url }}</a>
                </td>

                <td>
                    {{ item.buildDate ? (item.buildDate | date:'short') : '—' }}
                </td>

                <td>
                    <button 
                        class="btn btn-sm btn-outline-primary"
                        (click)="resync(item)"
                        [disabled]="resyncing[item.id]">
                        <i class="bi bi-arrow-repeat" [class.spin]="resyncing[item.id]"></i>
                    </button>
                </td>

                <td>
                    {{ lastResync[item.id] ? (lastResync[item.id] | date:'short') : '—' }}
                </td>
            </tr>
        </tbody>

        <tbody *ngIf="activeTab === 'prod'">
            <tr *ngFor="let item of prodItems">
                <td>
                    <span class="status-dot" [ngClass]="item.status"></span>&nbsp;&nbsp;&nbsp;&nbsp;
                     {{ item.title }}
                </td>
                <td>{{ item.group }}</td>

                <td>
                    <a [href]="item.url" target="_blank">{{ item.url }}</a>
                </td>

                <td>
                    {{ item.buildDate ? (item.buildDate | date:'short') : '—' }}
                </td>

                <td>
                    <button 
                        class="btn btn-sm btn-outline-primary"
                        (click)="resync(item)"
                        [disabled]="resyncing[item.id]">
                        <i class="bi bi-arrow-repeat" [class.spin]="resyncing[item.id]"></i>
                    </button>
                </td>

                <td>
                    {{ lastResync[item.id] ? (lastResync[item.id] | date:'short') : '—' }}
                </td>
            </tr>
        </tbody>
    </table>
</div>